<template>
  <div>
    <!-- Header -->

    <!-- Page content -->
    <b-container class="py-7 py-lg-8 pt-lg-9">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <h3>รายละเอียดรถ</h3>
              <hr />
              <p>ประเภทรถ : รถเช่า</p>
              <p>ทะเบียนรถ : หห-2340</p>
              <p>จังหวัด : นนทบุรี</p>
              <p>ยี่ห้อ : Toyota</p>
              <p>ปีผลิต : 2020</p>
              <p>ชนิดเครื่องยนตร์ : เบนซิน</p>
              <p>ขนาดเครื่องยนตร์ : 2400 แรงม้า</p>
              <p>ระบบขับเคลื่อน : 2 ล้อ</p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
    },
  },
};
</script>
